import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from './apiClient';

// ------------------ Thunks ------------------

// Fetch all ICT Sales Cards
export const fetchICTSalesCards = createAsyncThunk(
  'ictSalesCards/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.get('/ictSalesCard/');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Insert a new ICT Sales Card
export const insertICTSalesCard = createAsyncThunk(
  'ictSalesCards/insert',
  async (newCard, { rejectWithValue }) => {
    try {
      const response = await apiClient.post('/ictSalesCard/', newCard);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update an existing ICT Sales Card
export const updateICTSalesCard = createAsyncThunk(
  'ictSalesCards/update',
  async (updatedCard, { rejectWithValue }) => {
    try {
      const response = await apiClient.put(`/ictSalesCard/${updatedCard.id}/`, updatedCard);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Delete an ICT Sales Card
export const deleteICTSalesCard = createAsyncThunk(
  'ictSalesCards/delete',
  async (id, { rejectWithValue }) => {
    try {
      await apiClient.delete(`/ictSalesCard/${id}/`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ------------------ Slice ------------------
const ictSalesCardSlice = createSlice({
  name: 'ictSalesCards',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchICTSalesCards.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchICTSalesCards.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchICTSalesCards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // INSERT
      .addCase(insertICTSalesCard.fulfilled, (state, action) => {
        state.data.push(action.payload);
      })
      .addCase(insertICTSalesCard.rejected, (state, action) => {
        state.error = action.payload;
      })

      // UPDATE
      .addCase(updateICTSalesCard.fulfilled, (state, action) => {
        const index = state.data.findIndex((item) => item.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(updateICTSalesCard.rejected, (state, action) => {
        state.error = action.payload;
      })

      // DELETE
      .addCase(deleteICTSalesCard.fulfilled, (state, action) => {
        state.data = state.data.filter((item) => item.id !== action.payload);
      })
      .addCase(deleteICTSalesCard.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default ictSalesCardSlice.reducer;
